import { useEffect, useState } from "react";

const DEFAULT_FONT_SIZE = 100;

export function useUiPreferences() {
  const [theme, setTheme] = useState(() => localStorage.getItem("babyplanner_theme") || "light");
  const [fontSize, setFontSize] = useState(() => Number(localStorage.getItem("babyplanner_font") || DEFAULT_FONT_SIZE));

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    localStorage.setItem("babyplanner_theme", theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.style.setProperty("--font-scale", String(fontSize / DEFAULT_FONT_SIZE));
    localStorage.setItem("babyplanner_font", String(fontSize));
  }, [fontSize]);

  return { theme, setTheme, fontSize, setFontSize };
}
